import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ContentCopy } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useSnackbar } from "notistack";

interface UUIDCellProps {
  // The UUID value
  value: string | null | undefined;
  // The number of characters of the UUID to display
  truncateLength?: number;
}

/**
 * Displays a truncated UUID with a tooltip and copy button.
 */
const UUIDCell: React.FC<UUIDCellProps> = ({ value, truncateLength = 8 }) => {
  const { enqueueSnackbar } = useSnackbar();

  if (!value) {
    return "-";
  }

  const truncated = value.slice(0, truncateLength);

  const handleCopy = () => {
    enqueueSnackbar("Copied to clipboard", { variant: "success" });
  };

  return (
    <Tooltip title={value}>
      <Box display="flex" alignItems="center" gap={0.5}>
        <Box component="span" fontFamily="monospace">
          {truncated}
        </Box>
        <CopyToClipboard text={value} onCopy={handleCopy}>
          <IconButton
            size="small"
            sx={{
              padding: 0.25,
              opacity: 0.6,
              "&:hover": { opacity: 1 },
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <ContentCopy fontSize="small" sx={{ fontSize: 14 }} />
          </IconButton>
        </CopyToClipboard>
      </Box>
    </Tooltip>
  );
};

export default UUIDCell;
